module.exports = __webpack_public_path__ + "img/304.31852e39.jpg";